export default __webpack_public_path__ + "dist/media/WordExcelBg.e6b76945.svg";